import { useAuthPasswordRestoreConfirmationMutation } from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';
import GraphQLApiUtils from '@shared/api/graphql/utils';

import { PasswordResetInputType, PasswordResetResultType, UsePasswordResetType } from './types';

const usePasswordReset = (): UsePasswordResetType => {
  const [mutation, mutationResult] = useAuthPasswordRestoreConfirmationMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: PasswordResetInputType) => {
    const mutationResult = await mutation({
      variables: { input },
    });

    return !!mutationResult.data?.passwordRestoreConfirmation?.ok;
  };

  const passwordRestoreConfirmationData = mutationResult.data?.passwordRestoreConfirmation;
  const hasErrors = !!passwordRestoreConfirmationData?.errors;
  const resetResultData: PasswordResetResultType['data'] = { ok: passwordRestoreConfirmationData?.ok };

  if (hasErrors) {
    resetResultData.errors = GraphQLApiUtils.errorsArrayToObject(passwordRestoreConfirmationData?.errors);
  }

  const result: PasswordResetResultType = {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    data: resetResultData,
  };

  return [request, result];
};

export default usePasswordReset;
